<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title class="headline">
        <span v-if="isEdit">{{ $t('message.edit') }}</span>
        <span v-else-if="isCreate">{{ $t('message.add') }}</span>
        <span v-else>{{ $t('message.details') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-show="isCreate">
          <v-container grid-list-md pt-0>
            <v-layout row wrap>
              <v-flex xs6>
                <v-select
                  :label="$t('message.delivery')"
                  data-vv-name="delivery"
                  :error-messages="errors.collect('delivery')"
                  :items="filteredCompanies"
                  item-text="name"
                  item-value="id"
                  v-model="form.deliveryId"
                  v-validate="formValidation.delivery"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-switch
                  :label="form.allowPayment ? $t('message.allowCharge') : $t('message.denyCharge')"
                  v-model="form.allowPayment"
                  color="primary"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="selectedCompany">
              <v-flex xs12>
                <v-text-field
                  :label="$t('message.responsibleName')"
                  v-model="selectedCompany.owner_name"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.telegramUser')"
                  v-model="selectedCompany.admin_telegram_user"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :label="$t('message.telephone')"
                  v-model="selectedCompany.phone"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="selectedCompany.delivery_prices">
                <v-layout row wrap>
                  <v-flex xs12>
                    <h4 class="title">Tarifas</h4>
                  </v-flex>
                  <v-flex xs12>
                    <v-data-table
                      :headers="headers"
                      :items="selectedCompany.delivery_prices"
                      hide-actions
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip bottom>
                          <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                          <span>{{ $t(`message.${props.header.text}`) }}</span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.country }}</td>
                        <td>{{ props.item.state }}</td>
                        <td>{{ props.item.city }}</td>
                        <td>{{ props.item.destination_country }}</td>
                        <td>{{ props.item.destination_state }}</td>
                        <td>{{ props.item.destination_city }}</td>
                        <td>{{ props.item.price + ' $'}}</td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

        <v-container grid-list-md pt-0 v-show="isView">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('message.responsibleName')"
                v-model="company.owner_name"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                :label="$t('message.telegramUser')"
                v-model="company.admin_telegram_user"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field :label="$t('message.telephone')" v-model="company.phone" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 v-if="company.delivery_prices">
              <v-layout row wrap>
                <v-flex xs12>
                  <h4 class="title">Tarifas</h4>
                </v-flex>
                <v-flex xs12>
                  <v-data-table :headers="headers" :items="company.delivery_prices" hide-actions>
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                        <span>{{ $t(`message.${props.header.text}`) }}</span>
                      </v-tooltip>
                    </template>
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.country }}</td>
                      <td>{{ props.item.state }}</td>
                      <td>{{ props.item.city }}</td>
                      <td>{{ props.item.destination_country }}</td>
                      <td>{{ props.item.destination_state }}</td>
                      <td>{{ props.item.destination_city }}</td>
                      <td>{{ props.item.price + '$'}}</td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn
          outline
          v-if="isCreate"
          @click="onSave"
          color="primary"
          small
        >{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_DELIVERY_COMPANIES } from "../../../store/modules/delivery/company/actions.type";

export default {
  name: "manageDeliveryCompany",
  props: {
    dialog: {
      required: false,
      default: false
    },
    isEdit: {
      required: false,
      default: false
    },
    isCreate: {
      required: false,
      default: false
    },
    isView: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: "originCountry", sortable: false, value: "country" },
        { text: "originState", sortable: false, value: "state" },
        { text: "originCity", sortable: false, value: "city" },
        {
          text: "destinationCountry",
          sortable: false,
          value: "destination_country"
        },
        {
          text: "destinationState",
          sortable: false,
          value: "destination_state"
        },
        { text: "destinationCity", sortable: false, value: "destination_city" },
        { text: "price", sortable: false, value: "price" }
      ],
      form: {
        deliveryId: null,
        allowPayment: false,
        valid: false
      },
      formValidation: {
        delivery: "required"
      },
      dialogModel: this.dialog,
      company: {
        owner_name: "",
        admin_telegram_user: "",
        phone: "",
        delivery_prices: []
      }
    };
  },
  created() {
    this.getDeliveryCompanies();
  },
  computed: {
    ...mapGetters(["deliveryCompanies", "linkedCompanies"]),
    filteredCompanies() {
      return this.deliveryCompanies.filter(delivComp => {
        let found = this.linkedCompanies.find(
          linkComp => linkComp.company.id === delivComp.id
        );
        return !found;
      });
    },
    selectedCompany() {
      return this.filteredCompanies.find(
        company => company.id === this.form.deliveryId
      );
    }
  },
  methods: {
    getDeliveryCompanies() {
      this.$store.dispatch(GET_DELIVERY_COMPANIES);
    },
    resetForm() {
      this.form.deliveryId = undefined;
      this.form.allowPayment = false;
      this.$validator.reset();
    },
    setValue(element) {
      this.company = element.company;

      this.form.deliveryId = element.delivery_company_id;
      this.form.allowPayment = false;
    },
    onClose() {
      this.$emit("update:dialog", false);
      this.resetForm();
    },
    async onSave() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          this.$emit("on-save", {
            delivery_company_id: this.form.deliveryId,
            allow_payment_to_delivery: this.form.allowPayment
          });

          this.$emit("update:dialog", false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style>
</style>
